import React from 'react';
import { Routes, Route, Navigate, HashRouter } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

import AdminLayout from './layouts/AdminLayout';
import CamperLayout from './layouts/CamperLayout';
import AuthHandoff from './pages/auth/AuthHandoff';
import HomePage from './pages/public/HomePage';
import Register from './pages/public/Register';
import Start from './pages/public/Start';

import AdminDashboard from './pages/admin/AdminDashboard';
import Users from './pages/admin/Users';
import Passes from './pages/admin/Passes';
import Bunkmates from './pages/admin/Bunkmates';
import ContentManager from './pages/admin/ContentManager';
import Settings from './pages/admin/Settings';
import LettersQueue from './pages/admin/LettersQueue';

import Dashboard from './pages/camper/Dashboard';
import Assembly from './pages/camper/Assembly';
import MessHall from './pages/camper/MessHall';
import Cabin from './pages/camper/Cabin';
import Campfire from './pages/camper/Campfire';
import Letters from './pages/camper/Letters';
import Bunkmate from './pages/camper/Bunkmate';
import Profile from './pages/camper/Profile';
import Upgrade from './pages/camper/Upgrade';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div className="min-h-screen bg-cream flex items-center justify-center">Loading...</div>;
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div className="min-h-screen bg-cream flex items-center justify-center">Loading...</div>;
  }
  
  const safeUser = Array.isArray(user) ? user[0] : user;
  
  if (!safeUser || safeUser.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

function App() {
  return (
    <HashRouter>
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/register" element={<Register />} />
          <Route path="/start" element={<Start />} />
          <Route path="/login" element={<AuthHandoff />} />

          {/* Admin Routes */}
          <Route path="/admin" element={
            <AdminRoute>
              <AdminLayout />
            </AdminRoute>
          }>
            <Route index element={<AdminDashboard />} />
            <Route path="users" element={<Users />} />
            <Route path="passes" element={<Passes />} />
            <Route path="bunkmates" element={<Bunkmates />} />
            <Route path="content" element={<ContentManager />} />
            <Route path="letters" element={<LettersQueue />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          {/* Camper Routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <CamperLayout />
            </ProtectedRoute>
          }>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="assembly" element={<Assembly />} />
            <Route path="messhall" element={<MessHall />} />
            <Route path="cabin" element={<Cabin />} />
            <Route path="campfire" element={<Campfire />} />
            <Route path="letters" element={<Letters />} />
            <Route path="bunkmate" element={<Bunkmate />} />
            <Route path="profile" element={<Profile />} />
            <Route path="upgrade" element={<Upgrade />} />
          </Route>
        </Routes>
      </AuthProvider>
    </HashRouter>
  );
}

export default App;